<main class="report-layout">
  <router-outlet></router-outlet>
</main>
